"use strict";

exports.__esModule = true;
exports.TimelineValueElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Device = require("../../Device");
var _Timeline = require("../../Timeline");
var _common = require("../common");
var _dec, _class, _TimelineValueElement;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays the latest value from a timeline.
 */
var TimelineValueElement = exports.TimelineValueElement = (_dec = _Device.DeviceContext.withContext, _dec(_class = (_TimelineValueElement = /*#__PURE__*/function (_Component) {
  function TimelineValueElement() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.renderSubscription = function (_ref) {
      var color = _ref.color,
        backgroundColor = _ref.backgroundColor;
      var _this$props = _this.props,
        timelineName = _this$props.timelineName,
        hideLabel = _this$props.hideLabel,
        device = _this$props.device;
      var timeline = (0, _Timeline.getTimelineDefinition)(timelineName);
      return /*#__PURE__*/_react["default"].createElement(_Timeline.TimelineSubscription, {
        defaultValue: null,
        timelineName: timelineName,
        query: {
          device: device == null ? void 0 : device.uuid
        },
        isCurrent: true
      }, function (packet) {
        return /*#__PURE__*/_react["default"].createElement(_Timeline.TimelineValue, _extends({}, (0, _common.getWidgetPositionProps)(_this.props), (0, _common.getWidgetFontProps)(_this.props), (0, _common.getWidgetInteractionProps)(_this.props), {
          color: color,
          backgroundColor: backgroundColor,
          timeline: timeline,
          value: packet instanceof Error ? undefined : packet,
          label: !hideLabel && (timeline.label || timeline.name)
        }));
      });
    };
    return _this;
  }
  _inheritsLoose(TimelineValueElement, _Component);
  var _proto = TimelineValueElement.prototype;
  _proto.render = function render() {
    var _this$props2 = this.props,
      device = _this$props2.device,
      color = _this$props2.color,
      backgroundColor = _this$props2.backgroundColor,
      backgroundColorSource = _this$props2.backgroundColorSource;
    if (backgroundColorSource) {
      return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
        deviceUuid: device == null ? void 0 : device.uuid
      }, (0, _common.getWidgetColorProps)(this.props)), this.renderSubscription);
    }
    return this.renderSubscription({
      color: color,
      backgroundColor: backgroundColor
    });
  };
  return TimelineValueElement;
}(_react.Component), _TimelineValueElement.defaultProps = {
  device: undefined
}, _TimelineValueElement)) || _class);